export enum VOTING_DATA_ERR_KEYS {
  NAME,
  SUBMIT_START,
  SUBMIT_END,
  BLUR_START,
  BLUR_END
}
